angular.module('iconoglobe')
.service('tooltipImages', ["$http", "$filter", "$q", 'httpCanceler', "promiseHandler", function($http, $filter, $q, httpCanceler, promiseHandler){

  var json;
  this.getImageList = function(page){
    httpCanceler.cancelRequest();
    if(page == "maps.world"){
      $http.get('app/tooltips/countriestooltip.json?1')
      .then(function(res){
        json = res.data;
      });
    } else if(page == "maps.us"){ 
      $http.get('app/tooltips/unitedstatestooltip.json?1')
      .then(function(res){
        json = res.data;
      });
    } else if(page == "maps.in"){ 
      $http.get('app/tooltips/indiatooltip.json?1')
      .then(function(res){
        json = res.data;
      });
    } else if(page == "maps.cn"){ 
      $http.get('app/tooltips/chinatooltip.json?1')
      .then(function(res){
        json = res.data;
      });
    } else if(page == "maps.ru"){ 
      $http.get('app/tooltips/russiatooltip.json?1')
      .then(function(res){
        json = res.data;
      });
    } else if(page == "maps.ca"){ 
      $http.get('app/tooltips/canadatooltip.json?1')
      .then(function(res){
        json = res.data;
      });
    }
  }

  this.getCurrrentImages = function(id){
    // promiseHandler.checkDebounce();
    
    // var deffered = $q.defer();
    
    // promiseHandler.updatePromise(deffered);

    var filtered = $filter('filter')(json, {'id': id}, true)[0];

    // if(filtered){
    //   deffered.resolve(filtered);
    // } else {
    //   deffered.reject();
    // }
    return filtered;
  }
}]);